import { render } from "./CreateEditSkillModal.vue?vue&type=template&id=5c133b3d&ts=true"
import script from "./CreateEditSkillModal.vue?vue&type=script&lang=ts"
export * from "./CreateEditSkillModal.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__